/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils
import { textStyles } from "utils/themeV2";


/* ++++++++++ --------------- EXPORT : AUTH PASSWORD RESET : STYLES --------------- ++++++++++ */
export default theme => ({
	passwordreset: {
		...textStyles
	}
});
